<script>
    import Calendar from "../../Calendar/Calendar.svelte";

    import DashboardContainer from "../../Dashboard/components/DashboardContainer.svelte";

    export let accountId = "";
    export let eventColour = "#8a3ed7";
    export let params = {};
</script>

<div class="relative flex flex-1 m-4">
    <DashboardContainer
        title={"Calendar Details"}
        disableToggle
        wrapperClass="flex-1"
    >
        <div class="flex flex-1 p-4">
            <Calendar
                {accountId}
                {eventColour}
                {params}
                isDoctorCalendar
                url={`/Account/view/${accountId}/tab=accountCalendar`}
            />
        </div>
    </DashboardContainer>
</div>
